import {
  BoardScheme,
  MenuResponseScheme,
  SubscribeAccFansListScheme,
  SubscribeGiftFansListScheme,
  SubscribeListScheme,
  TopFansListScheme,
} from '@/types/channel/menu/menu.schema';
import {
  BoardMenuModel,
  MenuModel,
  StarballoonFanModel,
  SubscribeAccFansListModel,
  SubscribeFanModel,
  SubscribeGiftFansListModel,
} from '@/types/channel/menu/menu.model';

/**
 * 본체
 */
export const mapMenuSchemaToModel = (
  scheme: MenuResponseScheme,
): MenuModel => ({
  fanList: scheme.topfans?.map(mapFanListSchemaToModel),
  subscribeAccFans: scheme.subscribeAccfans?.map(
    mapSubscribeAccFansListSchemaToModel,
  ),
  subscribeGiftFans: scheme.subscribeGiftfans?.map(
    mapSubscribeGiftFansListSchemaToModel,
  ),
  hiddenMenu: {
    showSooptoreMenu: scheme.menu?.sooptore ?? false,
    showBestMenu: scheme.menu?.best ?? false,
    showPartnerMenu: scheme.menu?.partner ?? false,
    showSupportersMenu: scheme.menu?.supporters ?? false,
  },
  boardList: scheme.board?.map(mapBoardListSchemaToModel),
});

export const mapFanListSchemaToModel = (
  scheme: TopFansListScheme,
): StarballoonFanModel => ({
  userId: scheme.userId,
  userNickname: scheme.userNick ? scheme.userNick : scheme.userId,
  profileImage: scheme.profileImage,
  totalGift: scheme.totalGift,
});

export const mapSubscribeFanListSchemaToModel = (
  scheme: SubscribeListScheme,
): SubscribeFanModel => ({
  userId: scheme.userId,
  profileImage: scheme.profileImage,
  userNickname: scheme.userNick ? scheme.userNick : scheme.userId,
});

export const mapSubscribeAccFansListSchemaToModel = (
  scheme: SubscribeAccFansListScheme,
): SubscribeAccFansListModel => ({
  userId: scheme.userId,
  userNickname: scheme.userNick ? scheme.userNick : scheme.userId,
  profileImage: scheme.profileImage,
  accFirstPaymentDate: scheme.accFirstPaymentDate,
  accPaymentCount: scheme.accPaymentCount,
  firstPaymentDate: scheme.firstPaymentDate,
});

export const mapSubscribeGiftFansListSchemaToModel = (
  scheme: SubscribeGiftFansListScheme,
): SubscribeGiftFansListModel => ({
  userId: scheme.userId,
  userNickname: scheme.userNick ? scheme.userNick : scheme.userId,
  profileImage: scheme.profileImage,
  accumulateSubsGiftScoreCnt: scheme.accumulateSubsGiftScoreCnt,
});

export const mapBoardListSchemaToModel = (
  scheme: BoardScheme,
): BoardMenuModel => ({
  boardType: scheme.displayType,
  boardName: scheme.name,
  bbsId: scheme.bbsNo ?? 0,
  auth: scheme.authNo ?? 0,
});
